import { createContext, PropsWithChildren } from 'react';
import { FieldValues, FormProviderProps as ReactFormProviderProps } from 'react-hook-form';
import { ObjectSchema } from 'yup';

export type FormProviderContextProps<
  TFieldValues extends FieldValues,
  TContext = unknown,
  TTransformedValues extends FieldValues | undefined = undefined,
> = ReactFormProviderProps<TFieldValues, TContext, TTransformedValues> &
  PropsWithChildren & {
    validation: ObjectSchema<object>;
  };

interface FormProviderProps {
  validation?: ObjectSchema<object>;
}

const FormProviderDefaultValues: FormProviderProps = {
  validation: undefined,
};
export const FormProviderContext = createContext<FormProviderProps>(FormProviderDefaultValues);
